module.exports = __webpack_public_path__ + "media/svg-new/monsterblue-5e56eb88.svg";